import React from "react";
import { Title } from "../styles";

export default function CheckoutHeader() {
  return <Title>Escolha como pagar</Title>;
}
